import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {PagesItem} from "./StyledComponents";
import {FiPlusSquare} from "react-icons/fi";
import IconButton from '@mui/material/IconButton';
import {setSheetList} from "../store/reducers/availableSheets";
import {HiOutlineTrash} from "react-icons/hi2";


function PagesSection({sheets, switchSheet, addSheet, activeIndex}) {
    const dispatch = useDispatch();
    const activeSheet = useSelector((state) => state.activeSheet).sheet;

    const delSheet = () => {
        if (sheets.length > 1) {
            const tmpSheets = sheets.filter((sheet) => sheet.id !== activeSheet.id);
            dispatch(setSheetList(tmpSheets))
            switchSheet(tmpSheets.length - 1, tmpSheets)
        }
    };

    return (
        <div className="pages-container">
            {
                sheets.map((m, i) => (
                    <div key={i} className={`page-item gnr-h-204 gnr-w-240 ${(activeIndex === i) && 'border_marked'}`}
                         onClick={() => {
                             switchSheet(i)
                         }}
                         style={{
                             backgroundImage: `url(${m.thumbnail})`,
                             backgroundSize: 'contain',
                             backgroundRepeat: 'no-repeat',
                             backgroundPosition: 'center',
                         }}
                    >{
                        activeSheet.id === m.id &&
                        <IconButton className={'delete-slide-btn'} aria-label="delete" onClick={delSheet}>
                            <HiOutlineTrash color='#ff0000' size={16}/>
                        </IconButton>
                    }
                    </div>
                ))
            }
            <PagesItem className='add-page' onClick={() => addSheet(sheets.length)}>
                <FiPlusSquare size={30}/>
            </PagesItem>
        </div>
    );
}

export default PagesSection;
